import { defineComponent, useListeners, useSlots, computed, inject, watch } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import { usePagination } from '../../composables/pagination/index.js';
import { useTableRow } from '../../composables/table-row/index.js';
import HoistComponent from '../hoist-component/HoistComponent.vue.js';
import UiName from '../ui-name/UiName.vue.js';
import UiValue from '../ui-value/UiValue.vue.js';
import UiValueBar from '../ui-value-bar/UiValueBar.vue.js';
import UiPagination from '../ui-pagination/UiPagination.vue.js';
import { showResults, showNoResults } from '../../helpers/data.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PortfolioPositionsTopFlop",
  props: {
    locale: { type: null, required: true },
    itemsPerPage: { type: Number, required: false, default: 10 },
    id: { type: null, required: true },
    type: { type: null, required: true },
    maxItems: { type: Number, required: false },
    valueBarRange: { type: null, required: false, default: "relative" }
  },
  emits: ["store-error", "data-load", "table-row-key-click", "table-row-click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const listeners = useListeners();
    const slots = useSlots();
    const headers = computed(() => {
      return [
        {
          key: "name",
          label: translate("portfolioPositionsTopFlop.name"),
          subtitle: translate("portfolioPositionsTopFlop.isin")
        },
        {
          key: "lastPrice",
          label: translate("portfolioPositionsTopFlop.lastPrice"),
          subtitle: translate("portfolioPositionsTopFlop.lastPriceDateTime")
        },
        {
          key: "unrealizedPerformanceRelative",
          label: translate("portfolioPositionsTopFlop.unrealizedPerformanceRelative"),
          subtitle: translate("portfolioPositionsTopFlop.unrealizedPerformance", { currency: textFormat(portfolioCurrency.value) })
        },
        {
          key: "unrealizedPerformanceBar",
          label: translate("portfolioPositionsTopFlop.unrealizedPerformanceBar")
        },
        {
          key: "weight",
          label: translate("portfolioPositionsTopFlop.weight"),
          subtitle: translate("portfolioPositionsTopFlop.marketValue", { currency: textFormat(portfolioCurrency.value) })
        }
      ];
    });
    const items = computed(() => {
      var _a, _b;
      return (_b = (_a = storeData.value) == null ? void 0 : _a.positions) != null ? _b : null;
    });
    const portfolioCurrency = computed(() => {
      var _a;
      return (_a = storeData.value) == null ? void 0 : _a.portfolio.currency;
    });
    const maxValue = computed(() => {
      var _a, _b;
      return (_b = (_a = storeMeta.value) == null ? void 0 : _a.unrealizedPerformance.maximum) != null ? _b : 1;
    });
    const totalItems = computed(() => {
      var _a, _b;
      return (_b = (_a = storeMeta.value) == null ? void 0 : _a.pagination.total) != null ? _b : 0;
    });
    const hasActionsSlotEnabled = computed(() => {
      return Object.prototype.hasOwnProperty.call(slots, "table:body:row:cell(actions):content");
    });
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter"),
      dateFormatter: inject("dateFormatter")
    });
    const { translate, textFormat, numberFormat, dateFormat } = localizationSupport;
    const tableRow = useTableRow(listeners, emits);
    const { tableRowAttributes, hasTableRowClickListener, hasTableRowKeyClickListener, tableRowEvents, onTableRowKeyClick } = tableRow;
    const pagination = usePagination(props, totalItems);
    const { totalPages, activePageOffset, onClickPagination } = pagination;
    const componentInputs = computed(() => {
      var _a;
      return {
        itemsPerPage: props.itemsPerPage,
        pageOffset: activePageOffset.value,
        id: props.id,
        type: props.type,
        maxItems: (_a = props.maxItems) != null ? _a : null,
        valueBarRange: props.valueBarRange,
        language: props.locale
      };
    });
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits
    );
    const { storeData, storeMeta, isLoadingStoreData } = storeModule;
    watch(
      () => [props.locale, props.itemsPerPage, activePageOffset.value, props.id, props.type, props.maxItems, props.valueBarRange],
      () => {
        pagination.activePageOffset.value = 0;
      }
    );
    return { __sfc: true, props, emits, listeners, slots, headers, items, portfolioCurrency, maxValue, totalItems, hasActionsSlotEnabled, localizationSupport, translate, textFormat, numberFormat, dateFormat, tableRow, tableRowAttributes, hasTableRowClickListener, hasTableRowKeyClickListener, tableRowEvents, onTableRowKeyClick, pagination, totalPages, activePageOffset, onClickPagination, componentInputs, storeModule, storeData, storeMeta, isLoadingStoreData, HoistComponent, UiName, UiValue, UiValueBar, UiPagination, showResults, showNoResults };
  }
});

export { _sfc_main as default };
